/* eslint-disable */
import $ from 'jquery';
/* eslint-enable */


let additional = 1;

const cloneUpdateAndInsert = (el, before) => {
  const newEl = el.clone();
  newEl.attr('id', newEl.attr('id').replace(/0/g, additional));
  newEl.html(newEl.html().replace(/0/g, additional));
  newEl.insertBefore(before);
};

$('#add-child').on('click', function () {
  additional += 1;
  cloneUpdateAndInsert($('#Form_RegistrationForm_ChildFirstNames0ChildMiddleNames0ChildSurname0ChildGender0ChildDateOfBirth0ChildWhangai0_Holder'), this);
});

$('input.hapu-check').on('click', function () {
  // get the iwi ID from this action by processing the ID attribute of this element eg: 'Form_RegistrationForm_IwiID1HapuID_13' Iwi id number is between the IwiID and HapuID
  var iwiID = $(this).attr("id").substring($(this).attr("id").indexOf("IwiID") + 5, $(this).attr("id").indexOf("HapuID"))
  if ($(this).is(":checked")) {
    $('#Form_RegistrationForm_IwiID_' + iwiID).prop("checked", true);
    $('#Form_EditIwiForm_IwiID_' + iwiID).prop("checked", true);
  }
});

$("input.iwi-checkbox").on("click", function () {
  // get the iwi ID from this action by processing the ID attribute of this element eg: 'Form_RegistrationForm_IwiID_1'
  var iwiID = $(this).attr("id").substring($(this).attr("id").indexOf("IwiID_") + 6)
  if ($(this).is(":not(:checked)")) {
    //find each input element that starts with 'Form_RegistrationForm_IwiID' followed by the ID of this element (ie: Form_RegistrationForm_IwiID1... ) and uncheck them
    $("input[id^='Form_RegistrationForm_IwiID" + iwiID + "']").each(function () {
      $(this).prop("checked", false)
    });
    $("input[id^='Form_EditIwiForm_IwiID" + iwiID + "']").each(function () {
      $(this).prop("checked", false)
    });
  }
})
$("#Form_RegistrationForm_SameAsPostal").on("click", function () {
  const checked = $(this).is(":checked");
  if (checked) {
    $("#Form_RegistrationForm_StreetNo").val("");
    $("#Form_RegistrationForm_StreetName").val("");
    $("#Form_RegistrationForm_Suburb").val("");
    $("#Form_RegistrationForm_City").val("");
    $("#Form_RegistrationForm_PostCode").val("");
    $("#Form_RegistrationForm_Country").val("");
  }
  $("#Form_RegistrationForm_StreetNo").prop("disabled", checked);
  $("#Form_RegistrationForm_StreetName").prop("disabled", checked);
  $("#Form_RegistrationForm_Suburb").prop("disabled", checked);
  $("#Form_RegistrationForm_City").prop("disabled", checked);
  $("#Form_RegistrationForm_PostCode").prop("disabled", checked);
  $("#Form_RegistrationForm_Country").prop("disabled", checked);
});

